import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cachedContent = null;
let fetchPromise = null;

const toBlocks = (data) => {
  if (Array.isArray(data)) return Object.fromEntries(data.map(b => [b.key, b.value]));
  if (Array.isArray(data?.blocks)) return Object.fromEntries(data.blocks.map(b => [b.key, b.value]));
  return data && typeof data === 'object' ? data : {};
};

export const useSiteContent = () => {
  const [content, setContent] = useState(cachedContent || {});

  useEffect(() => {
    if (cachedContent) { setContent(cachedContent); return; }
    if (!fetchPromise) {
      fetchPromise = axios.get(`${API}/site-content`)
        .then(r => {
          const blocks = toBlocks(r.data);
          cachedContent = blocks;
          return blocks;
        })
        .catch(() => ({}));
    }
    fetchPromise.then(data => setContent(data));
  }, []);

  return content;
};
